/**
 * Created by asiulik on 19.05.2017.
 */

define(function(){

   function History(){}

   History.prototype.setHistory = function(url){
       history.pushState({}, '', url);
   };

    History.prototype.updateHistory = function(url){
        history.replaceState({}, '', url);
    };

   return History;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/page/pageHistory.js